import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-invalid"]
const _hoisted_2 = {
  for: "name",
  class: "parking-form__field-label col-0-8 main-m font-m align-r"
}
const _hoisted_3 = {
  key: 0,
  class: "main-alert font-size-14 parking-form__field-error"
}

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ParkingAvailable } from "@/apiGenerate/medserver";
import EsModal from "../modals/esModal.vue";
import { InputText } from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esParkingForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    parking: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const nameSubmitError = ref(false);
const localParking = ref<ParkingAvailable>({
  doctorUuid : '',
  uuid: '',
  parking: ''
})

watch (() => props.isOpen, (isOpen) => {
  if (!isOpen) return;

  nameSubmitError.value = false;
  if (props.parking) {
    localParking.value = { ...props.parking };
  }
});

/**
 * Closes the parking modal with confirmation data.
 * @param isConfirmed - Whether the modal action was confirmed.
 */
const closeFormModal = () => {
  emit('modal-close');
}

const confirmFormModal = async () => {
  if (localParking.value.parking.trim().length > 0) {
    try {
      await props.confirmMethod(localParking.value);
    } catch {
      throw t('error.DEFAULT');
    }
  } else {
    nameSubmitError.value = true;
    throw t('settings.params.account.institutes.portailPatient.parking.nameRequired');
  }
}

const onUpdateVisible = (value: boolean) => {
  if (!value) {
    closeFormModal();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createBlock(EsModal, {
    title: props.header,
    "is-open": props.isOpen,
    dismissable: "",
    "onUpdate:visible": onUpdateVisible
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_es_modal_footer, {
        onModalCancel: closeFormModal,
        confirmModalMethod: () => confirmFormModal()
      }, null, 8, ["confirmModalMethod"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "w-full parking-form__field",
        "data-invalid": nameSubmitError.value
      }, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(t)('settings.label.instituteInformation.name')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
        ]),
        _createVNode(_unref(InputText), {
          type: "text",
          name: "name",
          id: "name",
          class: "parking-form__field-input w-full",
          size: "small",
          modelValue: localParking.value.parking,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localParking.value.parking) = $event)),
          invalid: nameSubmitError.value
        }, null, 8, ["modelValue", "invalid"]),
        (nameSubmitError.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.parking.nameRequired')), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title", "is-open"]))
}
}

})